import { render, staticRenderFns } from "./ExclGsttran.vue?vue&type=template&id=57f1dd66&"
import script from "./ExclGsttran.vue?vue&type=script&lang=js&"
export * from "./ExclGsttran.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports